<template>
<div style="margin-left:12.5%;margin-right:12.5%;background-color:#ffffff;border:1px solid #eeeeee;padding:20px;">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/RC/reportCenter' }">{{ $route.meta.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="width:100%;height:40px;">
        <div class="top_buttons" style="float:left;text-align:left;">
            <span style="font-weight:bold;color:#303133;">选择任务：</span>
            <el-select v-model="selected_task" placeholder="" style="width:170px;margin-left:10px;" clearable @change="select_task">
                <el-option v-for="(task_name ,index) in task_name_list" :label="task_name" :value="index" :key="index"></el-option>
            </el-select>
        </div>
        <div class="search" style="float:right;">
            <!-- 通过在form上添加@submit.native.prevent，可以支持在input上添加@keyup.native.enter，否则直接添加回车事件会有问题 -->
            <el-form :inline="true" :model="formInline" @submit.native.prevent>
            <el-form-item>
            <el-input
            placeholder="请输入搜索信息"
            v-model="formInline.search_info"
            @keyup.native.enter="search"
            clearable>
            </el-input>
            </el-form-item>
            <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            </el-form-item>
            </el-form>
        </div>
    </div>
    <div style="clear:both;text-align:left;margin-bottom:10px;">
        <!-- 20240831 原先的导出功能停用，改为导出一份全量的结果数据 -->
        <!-- <el-button icon="el-icon-download" type="primary" :disabled="!selected_company" @click="download_report('group_motivations', 'company_motivations')">下载公司级报告(动机结果)</el-button>
        <el-button icon="el-icon-download" type="primary" :disabled="!selected_company" @click="download_report('group_resource', 'company_resource')" style="margin-left:10px;">下载公司级报告(激励资源)</el-button>
        <el-button icon="el-icon-download" type="primary" :disabled="!selected_company" @click="download_report('personal_details', 'company_risk')" style="margin-left:10px;">下载公司级报告(离职风险)</el-button> -->
        <el-button icon="el-icon-download" type="primary" @click="download_report_full">下载结果报告</el-button>
    </div>
    <div>
        <el-table
        :data="rc_results"
        border
        stripe
        style="width: 100%">
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="real_name" label="评估人" min-width="16%">
                <template slot-scope="scope">
                    <div v-if="scope.row.is_superior=='是'">
                        <span>{{ scope.row.real_name }}</span><span style="color:#F56C6C;font-weight:bold;">(上级)</span>
                    </div>
                    <div v-else>{{ scope.row.real_name }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="email" label="邮箱" min-width="27%"></el-table-column>
            <el-table-column prop="superior_name" label="直属上级姓名" min-width="16%"></el-table-column>
            <el-table-column prop="superior_email" label="直属上级邮箱" min-width="27%"></el-table-column>
            <el-table-column prop="status" label="评估状态" min-width="14%">
                <template slot-scope="scope">
                    <div v-if="scope.row.status=='未开始'" class="not_start">{{ scope.row.status }}</div>
                    <div v-if="scope.row.status=='进行中'" class="non_finished_status">{{ scope.row.status }}</div>
                    <div v-if="scope.row.status=='已提交'" class="finished_status">{{ scope.row.status }}</div>
                </template>
            </el-table-column>
            <!-- 20240831 报告功能暂停使用 -->
            <!-- <el-table-column prop="operation" label="报告下载" min-width="28%">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="primary"
                    v-if="scope.row.is_superior=='是'"
                    :disabled="scope.row.status!='已提交'"
                    @click="download_report('group_motivations', 'group_motivations', scope.row)">团队报告(动机结果)</el-button>
                    <el-button
                    size="mini"
                    type="primary"
                    v-if="scope.row.is_superior=='是'"
                    :disabled="scope.row.status!='已提交'"
                    @click="download_report('group_resource', 'group_resource', scope.row)">团队报告(激励资源)</el-button><br v-if="scope.row.is_superior=='是'" />
                    <el-button
                    size="mini"
                    type="primary"
                    v-if="scope.row.is_superior=='是'"
                    :disabled="scope.row.status!='已提交'"
                    style="margin-top:5px;"
                    @click="download_report('personal_details', 'group_risk', scope.row)">团队报告(离职风险)</el-button>
                    <el-button
                    size="mini"
                    type="primary"
                    v-if="scope.row.is_superior=='否'"
                    :disabled="scope.row.status!='已提交'"
                    @click="download_report('personal_details', 'personal_report', scope.row)">个人报告</el-button>
                </template>
            </el-table-column> -->
        </el-table>
    </div>
    <div style="margin-top:10px;" v-if="rc_results.length > 0">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageinfo.count"
            :page-sizes="pageinfo.page_sizes"
            :page-size="pageinfo.page_size"
            layout="total, sizes, prev, pager, next"
            :total="pageinfo.count">
        </el-pagination>
    </div>
    <!-- 下面的内容用于导出pdf，不能展示，使用position:absolute;top:-9999px;将其移出视野，让用户不感知 20240831暂停使用 -->
    <!-- <result-details 
    ref="result_details"
    :rc_result_info="rc_result_info"
    :report_type="report_type"
    id="personal_details"
    style="position:absolute;top:-9999px;width:100%;">
    </result-details>
    <div id="group_motivations" style="padding:10px;position:absolute;top:-9999px;">
        <div style="text-align:left;">
            <p style="font-size:17px;font-weight:bold;">
                <span>下属人数：</span><span style="color:#409EFF;font-weight:bold;">{{ subordinate_count }}</span>
            </p>
        </div>
        <div id="plot1" style="width:900px;height:800px;"></div>
        <div id="plot2" style="width:900px;height:800px;"></div>
    </div>
    <div id="group_resource" style="padding:10px;position:absolute;top:-9999px;">
        <div id="plot3" style="width:900px;height:800px;margin-top:15px;"></div>
    </div> -->
</div>
</template>

<script>
import postdata from "@/api/postData.js";
// import resultDetails from '../MyAssessment/RC_results_details.vue';
import getdata from "@/api/getData.js";
import PdfLoader from "../../api/htmlToPdf.js";
export default {
    created() {
        // this.get_company_list();
        this.get_task_list();
    },
    data() {
        return {
            download_file: {
                file_name: 'Assessment_results_rc.xlsx'
            },
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 10,
                page_sizes: [1, 10, 20, 50, 100],
            },
            rc_result_info: null,
            subordinate_count: 0, 
            rc_results: [],
            selected_company: '',
            selected_task: '',
            company_list: [],
            task_name_list: [],
            form: {},
            query_info: '',
            formInline: {
                search_info: '',
                search_result: [],
            },
            report_type: 'personal_report',
            task_id_list: [],
            task_id: null,
        };
    },
    components: {
        // resultDetails,
    },
    methods: {
        get_company_list() {
            getdata.getList("getRCCompanyList")
            .then(resp => {
                if(resp.data.code == 200){
                    this.company_list = resp.data.data; 
                    this.task_id_list = resp.data.task_id_list;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        get_task_list() {
            getdata.getList("getRCTaskList")
            .then(resp => {
                if(resp.data.code == 200){
                    this.task_name_list = resp.data.data; 
                    this.task_id_list = resp.data.task_id_list;
                }else {
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                    })
                }
                
            })
            .catch(err => {
                console.log(err);
            });
        },
        select_company() {
            this.task_id = this.task_id_list[this.selected_company];
            this.getUserInfo(-1, '', this.company_list[this.selected_company]);
        },
        select_task() {
            this.task_id = this.task_id_list[this.selected_task];
            this.getUserInfo(-1, '', this.task_name_list[this.selected_task]);
        },
        getUserInfo(id, query_info, task_name) {
            id = id||-1;      // 设置参数默认值为-1
            query_info = query_info||'';
            // const loading = this.$loading({
            //     lock: true, // lock的修改符--默认是false
            //     text: '正在加载，请稍后...', // 显示在加载图标下方的加载文案
            //     spinner: 'el-icon-loading', // 自定义加载图标类名
            //     background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
            // })
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
                query_info: query_info,
                user_id: id,
                task_name: task_name,
                // task_id: this.task_id,
            }
            
            getdata.getListP("getRCUserInfo", params)
            .then(resp => {
                // console.log(resp);
                if(resp.data.code == 200){
                    if(id==-1){
                        this.rc_results = resp.data.data;
                        this.pageinfo.count = resp.data.count;
                    }else{
                        // 因为form是字典，所以要使用data[0]赋值
                        this.form = resp.data.data[0];
                    }  
                }
                // loading.close();
            })
            .catch(err => {
                console.log(err);
                // loading.close();
            });
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        search() {
            // if(this.selected_company != ''){
            this.getUserInfo(-1, this.formInline.search_info, this.task_name_list[this.selected_task]);
            // }
        },
        download_report_full() {
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP("exportRCFullyResults", JSON.stringify(this.download_file), params)
              .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        downloadReport(id, report_type) {
            let report_name;
            if(report_type == 'personal_report'){
                report_name = '个人报告-' + this.form['real_name'];
            }else if(report_type == 'group_risk'){
                report_name = '团队报告-离职风险';
            }else if(report_type == 'group_motivations'){
                report_name = '团队报告-动机结果';
            }else if(report_type == 'group_resource'){
                report_name = '团队报告-激励资源';
            }else if(report_type == 'company_risk'){
                report_name = '公司级报告-离职风险';
            }else if(report_type == 'company_motivations'){
                report_name = '公司级报告-动机结果';
            }else if(report_type == 'company_resource'){
                report_name = '公司级报告-激励资源';
            }
            this.$nextTick(() => {
                let ele = document.getElementById(id);
                let pdf = new PdfLoader(ele, report_name, "el-table__row");
                pdf.getPDF();
            })
        },
        download_report(id, report_type, row) {
            report_type = report_type||'';
            row = row||null;
            this.report_type = report_type;
            let params;
            if(row != null){
                this.form = row;
                params = {
                    task_id: this.form['task_id'],
                    user_id: this.form['id'],
                    superior_id: this.form['superior_id'],
                    }
            }else{
                params = {
                    // 公司级的离职风险与团队级的共用接口，通过company_name入参来区分
                    company_name: this.company_list[this.selected_company],
                    }
            }
            
            // 根据报告类型，获取相应的数据 
            if(report_type == 'personal_report') {
                getdata.getListP("getRCPersonalReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.rc_result_info = resp.data.data;
                        this.$nextTick(() => {
                            this.downloadReport(id, report_type);
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }else if(report_type == 'group_risk') {
                getdata.getListP("getRCRetentionRiskReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.rc_result_info = resp.data.data;
                        this.$nextTick(() => {
                            this.downloadReport(id, report_type);
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }else if(report_type == 'group_motivations') {
                getdata.getListP("getRCMotivationReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.sat_plot_result = resp.data.sat_result;
                        this.imp_plot_result = resp.data.imp_result;
                        this.subordinate_count = resp.data.subordinate_count;
                        this.$nextTick(() => {
                            this.plot('plot1', this.sat_plot_result);
                            this.plot('plot2', this.imp_plot_result);
                        });
                        this.$nextTick(() => {
                            this.downloadReport(id, report_type);
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }else if(report_type == 'group_resource') {
                getdata.getListP("getRCResourceReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.resource_plot_result = resp.data.data;
                        this.$nextTick(() => {
                            this.plot('plot3', this.resource_plot_result);
                        });
                        this.$nextTick(() => {
                            this.downloadReport(id, report_type);
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }else if(report_type == 'company_risk') {
                getdata.getListP("getRCRetentionRiskReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.rc_result_info = resp.data.data;
                        this.$nextTick(() => {
                            this.downloadReport(id, report_type);
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }else if(report_type == 'company_motivations') {
                getdata.getListP("getRCCompanyMotivationReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.sat_plot_result = resp.data.sat_result;
                        this.imp_plot_result = resp.data.imp_result;
                        this.subordinate_count = resp.data.subordinate_count;
                        this.$nextTick(() => {
                            this.plot('plot1', this.sat_plot_result);
                            this.plot('plot2', this.imp_plot_result);
                        });
                        this.$nextTick(() => {
                            this.downloadReport(id, report_type);
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }else if(report_type == 'company_resource') {
                getdata.getListP("getRCCompanyResourceReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.resource_plot_result = resp.data.data;
                        this.$nextTick(() => {
                            this.plot('plot3', this.resource_plot_result);
                        });
                        this.$nextTick(() => {
                            this.downloadReport(id, report_type);
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        plot(id, p_data) {
            let echarts = require('echarts');
            // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
            let myChart = echarts.init(document.getElementById(id));
            // 指定图表的配置项和数据
            let option = {
                animation: false,   //重要！！这里要关闭动画，否则导出pdf时会无内容显示
                title: {
                    text: p_data.title
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'shadow'
                    }
                },
                legend: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    data: p_data.yAxis_data
                },
                series: p_data.series
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('page_size: ' + this.pageinfo.page_size);
            // if(this.formInline.search_info==''){
            //     this.getUserInfo();
            // }else{
            //     this.getUserInfo(-1, this.formInline.search_info);
            // }
            this.getUserInfo(-1, this.formInline.search_info, this.task_name_list[this.selected_task]);
            // console.log(this.pageinfo.page_size)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('current: ' + this.pageinfo.current);
            // if(this.formInline.search_info==''){
            //     this.getUserInfo();
            // }else{
            //     this.getUserInfo(-1, this.formInline.search_info);
            // }
            this.getUserInfo(-1, this.formInline.search_info, this.task_name_list[this.selected_task]);
            // console.log(this.pageinfo.current)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
    }
}
</script>

<style scoped>
.top_buttons > .el-button {
    font-size: 16px;
    /* font-weight: bold; */
}
.search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
}
::v-deep .el-button--mini {
    padding: 6px 5px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
}
.not_start {
    font-size: 12px;
    background: #f56c6c;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.non_finished_status {
    font-size: 12px;
    background: #E6A23C;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.finished_status {
    font-size: 12px;
    background: #67C23A;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
</style>

